/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PagePrescriptionDto } from '../model';
/**
 * AdminPrescriptionControllerApi - axios parameter creator
 * @export
 */
export const AdminPrescriptionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptionPdf1: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPrescriptionPdf1', 'id', id)
            const localVarPath = `/api/admin/prescription/{id}/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [patientId] 
         * @param {number} [doctorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptions: async (patientId?: number, doctorId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prescription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (doctorId !== undefined) {
                localVarQueryParameter['doctorId'] = doctorId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPrescriptionControllerApi - functional programming interface
 * @export
 */
export const AdminPrescriptionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPrescriptionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrescriptionPdf1(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrescriptionPdf1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [patientId] 
         * @param {number} [doctorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrescriptions(patientId?: number, doctorId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<PagePrescriptionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrescriptions(patientId, doctorId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminPrescriptionControllerApi - factory interface
 * @export
 */
export const AdminPrescriptionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPrescriptionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptionPdf1(id: number, options?: any): Promise<string> {
            return localVarFp.getPrescriptionPdf1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [patientId] 
         * @param {number} [doctorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrescriptions(patientId?: number, doctorId?: number, options?: any): Promise<PagePrescriptionDto> {
            return localVarFp.getPrescriptions(patientId, doctorId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPrescriptionControllerApi - object-oriented interface
 * @export
 * @class AdminPrescriptionControllerApi
 * @extends {BaseAPI}
 */
export class AdminPrescriptionControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPrescriptionControllerApi
     */
    public getPrescriptionPdf1(id: number, options?: AxiosRequestConfig) {
        return AdminPrescriptionControllerApiFp(this.configuration).getPrescriptionPdf1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [patientId] 
     * @param {number} [doctorId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPrescriptionControllerApi
     */
    public getPrescriptions(patientId?: number, doctorId?: number, options?: AxiosRequestConfig) {
        return AdminPrescriptionControllerApiFp(this.configuration).getPrescriptions(patientId, doctorId, options).then((request) => request(this.axios, this.basePath));
    }
}
